import { render, staticRenderFns } from "./FeatureConfigList.html?vue&type=template&id=3eb2dc33&"
import script from "./FeatureConfigList.vue?vue&type=script&lang=js&"
export * from "./FeatureConfigList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports